import React, { useEffect } from 'react'
import { Center, Input, InputGroup, InputProps, InputRightElement, Spinner } from '@chakra-ui/react'
import { useDebounce } from '../../../hooks'
import { useField } from 'formik'

type SearchBarInputProps = InputProps & {
  onSearch?: (text: string) => void
  isLoading?: boolean
  name: string
}

const SearchBarInput = React.forwardRef<HTMLInputElement, SearchBarInputProps>(
  ({ onSearch, isLoading, ...rest }, ref) => {
    const [field] = useField(rest.name)
    const debouncedSearchTerm = useDebounce(field.value, 350)

    useEffect(() => {
      if (onSearch) {
        onSearch(debouncedSearchTerm)
      }
    }, [debouncedSearchTerm, onSearch])

    return (
      <InputGroup>
        <Input ref={ref} {...field} {...rest} id={field.name} py={5} />
        {isLoading && (
          <InputRightElement h="100%">
            <Center h="100%">
              <Spinner size="sm" color="gray" />
            </Center>
          </InputRightElement>
        )}
      </InputGroup>
    )
  }
)

export default SearchBarInput

SearchBarInput.defaultProps = {
  type: 'text',
  placeholder: 'Search...',
  minW: '100px'
}
